import { render } from "./NoTemplateComponent.vue?vue&type=template&id=d0e6be8e"
import script from "./NoTemplateComponent.vue?vue&type=script&lang=js"
export * from "./NoTemplateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__